import { c, classy } from '@onfido/castor';
import React, { useState } from 'react';
import { withRef } from '../../utils';
import { FieldProvider } from './useField';
export { useField } from './useField';
/**
 * Use to wrap any input component (`Input`, `Textarea`, `Radio`, `Checkbox`)
 * to make `Validation` react to its `ValidityState`.
 *
 * @example
 * <Field>
 *   <Input minLength={3} required />
 *   <Validation state="error" if="valueMissing">
 *     Will show if [required] is invalid.
 *   </Validation>
 *   <Validation state="error" if="tooShort">
 *     Will show if [minLength] is invalid.
 *   </Validation>
 * </Field>
 */
export const Field = withRef(function Field({ disabled, onBlur, onChange, onInvalid, className, ...restProps }, ref) {
    const [field, setField] = useState(initial);
    function initial() {
        const reset = () => setField(initial);
        return { reset, validity: {} };
    }
    const update = (state) => setField((field) => ({ ...field, ...state }));
    return (React.createElement(FieldProvider, { value: { ...field, disabled } },
        React.createElement("div", { ...restProps, className: classy(c('field'), className), ref: ref, onBlur: (event) => {
                update({ touched: true, ...readInput(event) });
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
            }, onChange: (event) => {
                update({ touched: true, ...readInput(event) });
                onChange === null || onChange === void 0 ? void 0 : onChange(event);
            }, onInvalid: (event) => {
                update(readInput(event));
                onInvalid === null || onInvalid === void 0 ? void 0 : onInvalid(event);
            } })));
});
const readInput = (event) => {
    const { disabled, validity } = event.target;
    return { ...(disabled != null && { disabled }), validity };
};
//# sourceMappingURL=field.js.map